import { message } from 'antd'
import { uniqBy } from 'lodash'
import { useEffect, useReducer } from 'react'
import { GET_INVOICABLE_PAGE } from '../../api/orderManage'
import { history } from '../../redux/store'
import { allElementsEqual, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  State,
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSearchParamAction,
  setSelectedRowsAction,
} from './reducer'

export const handleJumpAddInvoice = (orderIds: string[]) => {
  history.push({
    pathname: '/srm/addinvoice',
    state: {
      orderIds,
    },
  })
}

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state

  useEffect(() => {
    getPageData(state)
    // eslint-disable-next-line
  }, [])

  const getPageData = async (state: State) => {
    const params = { ...state.paginationOption, ...state.searchParam }
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_INVOICABLE_PAGE({
      ...params,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: resdata, total: count },
          pageNo: res.data.pageNo,
        }),
      )
    }
    dispatch(setIsTableLoadingAction(false))
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    getPageData({
      ...state,
      ...{
        searchParam: value,
      },
    })
  }

  const handlePaginationChange = (page: number, pageSize?: number) => {
    dispatch(
      setPaginationOptionAction({
        pageNo: page,
        pageSize: pageSize,
      }),
    )
    getPageData({
      ...state,
      ...{
        paginationOption: {
          pageNo: page,
          pageSize: pageSize ? pageSize : 20,
        },
      },
    })
  }

  // 合并开票
  const onCombine = () => {
    if (!selectedRows.length) {
      message.warn('请先勾选需要开票的订单')
      return
    }
    if (!allElementsEqual(selectedRows.map((item) => item.platform))) {
      message.warn('只能勾选同一个平台的订单进行合并开票')
      return
    }
    handleJumpAddInvoice(selectedRows.map((item) => item.id))
  }

  const onSelectRow = (record: any, selected: boolean) => {
    if (selected) {
      dispatch(setSelectedRowsAction([...selectedRows, record]))
    } else {
      const newChecked = [...selectedRows]
      newChecked.splice(
        newChecked.findIndex((item) => item.id === record.id),
        1,
      )
      dispatch(setSelectedRowsAction(newChecked))
    }
  }

  const onSelectAll = (
    selected: boolean,
    checkedRows: any[],
    changeRows: any[],
  ) => {
    if (selected) {
      const newChecked = [...selectedRows, ...changeRows]
      dispatch(setSelectedRowsAction(uniqBy(newChecked, 'id')))
    } else {
      const newChecked = [...selectedRows]
      changeRows.forEach((item) => {
        newChecked.splice(
          newChecked.findIndex((c) => c.id === item.id),
          1,
        )
      })
      dispatch(setSelectedRowsAction(newChecked))
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onChangeCheck = () => {}

  return {
    state,
    handlePaginationChange,
    handleSearchClick,
    handleJumpAddInvoice,
    onCombine,
    onSelectRow,
    onSelectAll,
    onChangeCheck,
  }
}

export default useSetupHook
import { message } from 'antd'
import { uniqBy } from 'lodash'
import { useEffect, useReducer } from 'react'
import { GET_INVOICABLE_PAGE } from '../../api/orderManage'
import { history } from '../../redux/store'
import { allElementsEqual, isResponseCodeSuccess } from '../../tools/util'
import reducer, {
  State,
  initialState,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationOptionAction,
  setSearchParamAction,
  setSelectedRowsAction,
} from './reducer'

export const handleJumpAddInvoice = (orderIds: string[]) => {
  history.push({
    pathname: '/srm/addinvoice',
    state: {
      orderIds,
    },
  })
}

const useSetupHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { selectedRows } = state

  useEffect(() => {
    getPageData(state)
    // eslint-disable-next-line
  }, [])

  const getPageData = async (state: State) => {
    const params = { ...state.paginationOption, ...state.searchParam }
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_INVOICABLE_PAGE({
      ...params,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setDataSourceAction({
          dataSource: { data: resdata, total: count },
          pageNo: res.data.pageNo,
        }),
      )
    }
    dispatch(setIsTableLoadingAction(false))
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    getPageData({
      ...state,
      ...{
        searchParam: value,
      },
    })
  }

  const handlePaginationChange = (page: number, pageSize?: number) => {
    dispatch(
      setPaginationOptionAction({
        pageNo: page,
        pageSize: pageSize,
      }),
    )
    getPageData({
      ...state,
      ...{
        paginationOption: {
          pageNo: page,
          pageSize: pageSize ? pageSize : 20,
        },
      },
    })
  }

  // 合并开票
  const onCombine = () => {
    if (!selectedRows.length) {
      message.warn('请先勾选需要开票的订单')
      return
    }
    if (!allElementsEqual(selectedRows.map((item) => item.platform))) {
      message.warn('只能勾选同一个平台的订单进行合并开票')
      return
    }
    handleJumpAddInvoice(selectedRows.map((item) => item.id))
  }

  const onSelectRow = (record: any, selected: boolean) => {
    if (selected) {
      dispatch(setSelectedRowsAction([...selectedRows, record]))
    } else {
      const newChecked = [...selectedRows]
      newChecked.splice(
        newChecked.findIndex((item) => item.id === record.id),
        1,
      )
      dispatch(setSelectedRowsAction(newChecked))
    }
  }

  const onSelectAll = (
    selected: boolean,
    checkedRows: any[],
    changeRows: any[],
  ) => {
    if (selected) {
      const newChecked = [...selectedRows, ...changeRows]
      dispatch(setSelectedRowsAction(uniqBy(newChecked, 'id')))
    } else {
      const newChecked = [...selectedRows]
      changeRows.forEach((item) => {
        newChecked.splice(
          newChecked.findIndex((c) => c.id === item.id),
          1,
        )
      })
      dispatch(setSelectedRowsAction(newChecked))
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onChangeCheck = () => {}

  return {
    state,
    handlePaginationChange,
    handleSearchClick,
    handleJumpAddInvoice,
    onCombine,
    onSelectRow,
    onSelectAll,
    onChangeCheck,
  }
}

export default useSetupHook
